module.exports = __webpack_public_path__ + "static/n-0f5dd3126f3b87c01253981427fe8a19.webp";